import React from 'react';

const SmsIcon = ({ color, opacity, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6667 6H12.6667C13.403 6 14 6.59695 14 7.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V7.33333C2 6.59695 2.59695 6 3.33333 6H4.33333" stroke={color || "#1D1917"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity={opacity || 1} />
    <rect x="4.33594" y="2.6665" width="7.33333" height="6" rx="1" stroke={color || "#1D1917"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity={opacity || 1} />
    <path d="M11.3307 11.3333H4.66406" stroke={color || "#1D1917"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity={opacity || 1} />
  </svg>
);

SmsIcon.defaultProps = {
  size: 16,
  opacity: 1,
  color: "#1D1917",
};

export default SmsIcon;

